import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import {
  CreateStorageForm,
  CreateStorageResult,
} from "../Forms/CreateStorageForm";
import { StorageCaseInfoInput, StorageDefaultInfo } from "../storage.types";

interface CreateStorageModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (result?: CreateStorageResult) => void;
  onCancel: () => void;
  caseInfo?: StorageCaseInfoInput;
  defaultInfo?: StorageDefaultInfo | undefined;
}

export const CreateStorageModal: FC<CreateStorageModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  caseInfo,
  defaultInfo,
}) => {
  const handleSubmit = (result?: CreateStorageResult) => {
    onSubmit?.(result);
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateStorageForm
          width={700}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          caseInfo={caseInfo}
          defaultInfo={defaultInfo}
        />
      </Modal>
    </>
  );
};
